import {selectDomain} from '.';
import {createSelector} from '@reduxjs/toolkit';
import denormalizeObject from 'utils/denormalize-object';

export default createSelector([selectDomain], state => {
  return denormalizeObject(state.payments);
});
